import { ChevronRight } from 'lucide-react';
import whiteStarPic from '@/assets/images/white-star.png';
import topStarNightPic from '@/assets/images/top-star-night.png';
import platformInvestmentPic from "@assets/images/platform-icons/platform-investment.png";
import customerTrustPic from "@assets/images/platform-icons/customer-trust.png";
import investmentExperiencePic from "@assets/images/platform-icons/investment-experience.png";
import rareTargetsPic from "@assets/images/platform-icons/rare-targets.png";
import figureLogo from "@assets/logos/figure.png";
import spacexLogo from "@assets/logos/spacex.png";
import andurilLogo from "@assets/logos/anduril.png";
import openaiLogo from "@assets/logos/openai.png";
import bytedanceLogo from "@assets/logos/bytedance.png";
import xaiLogo from "@assets/logos/xai.png";
import groqLogo from "@assets/logos/groq.png";
import anthropicLogo from "@assets/logos/anthropic.png";
import neuralinkLogo from "@assets/logos/neuralink.png";
import stripeLogo from "@assets/logos/stripe.png";
import coreweaveLogo from "@assets/logos/coreweave.png";
import cohereLogo from "@assets/logos/cohere.png";
import perplexityLogo from "@assets/logos/perplexity.png";
import qrcodePic from "@assets/images/qrcode.png";
import whiteTextPic from "@assets/images/white-text.png";
import starNightPic from "@assets/images/star-night.png";
import astronautPic from "@assets/images/astronaut.png";

export default function Home() {
  return (
      <>
        <section className="container mx-auto px-4 pt-9 pb-8">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            <div className="lg:w-1/2">
              <h2 className="text-5xl font-bold mb-6">独角兽股权平台</h2>
              <div className="relative mb-8">
                <img src={whiteStarPic} alt="Star" className="float-left h-[24px] w-auto mr-3 mt-0.5" />
                <p className="text-xl text-white">
                  Polaris Invest，是一家独角兽股权投资服务平台。我们的愿景是平等地为每一位投资人提供全球最创新的科技企业的投资机会。我们相信科技对生产力提效、组织进化、社会变革和人类发展的深远影响。股权交易不仅为投资人创造财富，更是让投资人有机会去支持这些高速成长型公司，间接参与到这激动人心的未来探索之中。
                </p>
              </div>
              <button className="bg-white text-black px-8 py-3 rounded-full text-lg font-semibold hover:bg-gray-200 transition flex items-center gap-2">
                Explore Polaris <ChevronRight size={20} />
              </button>
            </div>
            <div className="lg:w-1/2">
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-r from-blue-500/30 to-purple-500/30 rounded-xl blur-xl"></div>
                <img
                  src={topStarNightPic}
                  alt="Space"
                  className="rounded-xl relative z-10"
                />
              </div>
            </div>
          </div>
        </section>
        {/* Stats Section */}
        <section className="bg-gray-900 py-20">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <img src={platformInvestmentPic} alt="通过平台投资" className="mx-auto h-[60px] w-auto object-contain mb-4 opacity-80 mix-blend-lighten" />
                <h3 className="text-3xl font-bold mb-2">$2亿+</h3>
                <p className="text-gray-400">通过平台投资</p>
              </div>
              <div className="text-center">
                <img src={customerTrustPic} alt="来自客户的信任" className="mx-auto h-[60px] w-auto object-contain mb-4 opacity-80 mix-blend-lighten" />
                <h3 className="text-3xl font-bold mb-2">700+</h3>
                <p className="text-gray-400">来自客户的信任</p>
              </div>
              <div className="text-center">
                <img src={investmentExperiencePic} alt="创业投资经验" className="mx-auto h-[60px] w-auto object-contain mb-4 opacity-80 mix-blend-lighten" />
                <h3 className="text-3xl font-bold mb-2">12年+</h3>
                <p className="text-gray-400">创业投资经验</p>
              </div>
              <div className="text-center">
                <img src={rareTargetsPic} alt="全球稀缺标的" className="mx-auto h-[60px] w-auto object-contain mb-4 opacity-80 mix-blend-lighten" />
                <h3 className="text-3xl font-bold mb-2">多样的</h3>
                <p className="text-gray-400">全球稀缺标的</p>
              </div>
            </div>
          </div>
        </section>

        {/* Portfolio Section */}
        <section className="container mx-auto px-4 py-20">
          <div className="flex items-center justify-center gap-3 mb-12">
            <img src={whiteStarPic} alt="Star" className="h-[24px] sm:h-[28px] md:h-[32px] lg:h-[36px] w-auto" />
            <h2 className="text-3xl font-bold">投资项目 2023-2025</h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { id: 'logo-1', name: 'Figure', value: '$39.5B Q1 2025', href: figureLogo },
              { id: 'logo-2', name: 'SpaceX', value: '$210B Q4 2024', href: spacexLogo },
              { id: 'logo-3', name: 'Anduril', value: '$16B Q4 2024', href: andurilLogo },
              { id: 'logo-4', name: 'OpenAI', value: '$15B Q3 2024', href: openaiLogo },
              { id: 'logo-5', name: 'ByteDance', value: '$250B Q3 2024', href: bytedanceLogo },
              { id: 'logo-6', name: 'xai', value: '$24B Q2 2024', href: xaiLogo },
              { id: 'logo-7', name: 'groq', value: '$2.2B Q1 2024', href: groqLogo },
              { id: 'logo-8', name: 'Anthropic', value: '$19B Q1 2024', href: anthropicLogo },
              { id: 'logo-9', name: 'Neuralink', value: '$5.2B Q1 2024', href: neuralinkLogo },
              { id: 'logo-10', name: 'OpenAI', value: '$90B Q4 2023', href: openaiLogo },
              { id: 'logo-11', name: 'Stripe', value: '$44B Q2 2023', href: stripeLogo },
              { id: 'logo-12', name: 'CoreWeave', value: '$7B Q3 2023', href: coreweaveLogo },
              { id: 'logo-13', name: 'cohere', value: '$7.2B Q2 2023', href: cohereLogo },
            ].map((company) => (
                <div key={company.id} className="bg-gray-900 p-6 rounded-xl">
                  <img src={company.href} alt={company.name} className="h-[45px] w-auto object-contain mb-4 opacity-80 mix-blend-lighten" />
                  <p className="text-yellow-400">{company.value}</p>
                </div>
            ))}
          </div>
        </section>

        {/* 已投项目 Section */}
        <section className="container mx-auto px-4 py-10">
          <div className="flex items-center justify-center gap-3 mb-12">
            <img src={whiteStarPic} alt="Star" className="h-[24px] sm:h-[28px] md:h-[32px] lg:h-[36px] w-auto" />
            <h2 className="text-3xl font-bold">已投项目</h2>
          </div>
          <div className="max-w-7xl mx-auto px-8 md:px-4 lg:px-8">
            <div className="flex flex-wrap justify-start gap-x-2 md:gap-x-1 gap-y-6">
              <img src={spacexLogo} alt="SpaceX" className="h-[45px] sm:h-[60px] md:h-[60px] lg:h-[60px] w-auto object-contain opacity-80 mix-blend-lighten" />
              <img src={xaiLogo} alt="X AI" className="h-[45px] sm:h-[60px] md:h-[60px] lg:h-[60px] w-auto object-contain opacity-80 mix-blend-lighten" />
              <img src={neuralinkLogo} alt="Neuralink" className="h-[45px] sm:h-[60px] md:h-[60px] lg:h-[60px] w-auto object-contain opacity-80 mix-blend-lighten" />
              <img src={cohereLogo} alt="cohere" className="h-[45px] sm:h-[60px] md:h-[60px] lg:h-[60px] w-auto object-contain opacity-80 mix-blend-lighten" />
              <img src={openaiLogo} alt="OpenAI" className="h-[45px] sm:h-[60px] md:h-[60px] lg:h-[60px] w-auto object-contain opacity-80 mix-blend-lighten" />
              <img src={groqLogo} alt="groq" className="h-[45px] sm:h-[60px] md:h-[60px] lg:h-[60px] w-auto object-contain opacity-80 mix-blend-lighten" />
              <img src={andurilLogo} alt="ANDURIL" className="h-[45px] sm:h-[60px] md:h-[60px] lg:h-[60px] w-auto object-contain opacity-80 mix-blend-lighten" />
              <img src={stripeLogo} alt="stripe" className="h-[45px] sm:h-[60px] md:h-[60px] lg:h-[60px] w-auto object-contain opacity-80 mix-blend-lighten" />
              <img src={anthropicLogo} alt="ANTHROPIC" className="h-[45px] sm:h-[60px] md:h-[60px] lg:h-[60px] w-auto object-contain opacity-80 mix-blend-lighten" />
              <img src={perplexityLogo} alt="perplexity" className="h-[45px] sm:h-[60px] md:h-[60px] lg:h-[60px] w-auto object-contain opacity-80 mix-blend-lighten" />
              <img src={bytedanceLogo} alt="ByteDance" className="h-[45px] sm:h-[60px] md:h-[60px] lg:h-[60px] w-auto object-contain opacity-80 mix-blend-lighten" />
              <img src={coreweaveLogo} alt="CoreWeave" className="h-[45px] sm:h-[60px] md:h-[60px] lg:h-[60px] w-auto object-contain opacity-80 mix-blend-lighten" />
              <img src={figureLogo} alt="FIGURE" className="h-[45px] sm:h-[60px] md:h-[60px] lg:h-[60px] w-auto object-contain opacity-80 mix-blend-lighten" />
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="container mx-auto px-4 py-20">
          <div className="rounded-2xl px-6 sm:px-12 md:px-18 lg:px-24 py-12 py-3 sm:py-6 md:py-9 lg:py-12">
            <div className="flex flex-col lg:flex-row items-center gap-8">
              <div className="lg:w-2/3 xl:w-2/3 text-center lg:text-left">
                <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-6 whitespace-nowrap">Are You In?</h2>
                <div className="flex flex-col md:flex-row items-center justify-center lg:justify-start gap-4 md:gap-24 lg:gap-32">
                  <div className="flex flex-col text-xl text-gray-400 gap-2">
                    <div className="flex items-center gap-2">
                      <img src={whiteStarPic} alt="Star" className="w-8 h-8" />
                      <span>联系我们</span>
                    </div>
                    <span>开启你的探索</span>
                  </div>
                  <img
                      src={qrcodePic}
                      alt="联系我们，开启你的探索"
                      className="w-24 h-24"
                  />
                </div>
                <div className="mt-12">
                  <img
                      src={whiteTextPic}
                      alt="Polaris Invest"
                      className="h-auto px-6 sm:px-0 sm:h-10 md:h-11 lg:h-12 opacity-80 mix-blend-lighten"
                  />
                </div>
              </div>
              <div className="w-full lg:w-2/3 flex justify-center items-center mt-8 lg:mt-0">
                <div className="relative inset-0 rounded-xl w-full h-full flex items-center justify-center">
                  <img
                      src={starNightPic}
                      alt="Star Night Background"
                      className="absolute inset-0 w-full h-full object-cover opacity-60 rounded-xl"
                  />
                  <img
                      src={astronautPic}
                      alt="Astronaut"
                      className="relative z-10 w-auto h-auto max-w-[300px] scale-90"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
  );
}
